<kilowant-header [isBuyer]="true" title="Orders"></kilowant-header>
<div class="wrapperMain mainAccountDetailsMain accountDetails">
  <div class="form buyer">
    <mat-tab-group mat-align-tabs="start" (selectedTabChange)="tabChanged($event)" #tabs>
      <mat-tab>
        <ng-template mat-tab-label> Open </ng-template>
        @if (buyOffers==null || buyOffers.length==0) {
          <div class="info-text">
            There are currently no orders
          </div>
        }
        @if (buyOffers!=null && buyOffers.length>0) {
          <div>
            <table #openOfferTable="matSort" mat-table matSort (matSortChange)="sortDataEvent($event)"
              [dataSource]="buyOffers" matSortActive="ServiceStart" matSortDisableClear="true" matSortDirection="asc"
              class="offer-summmary-table in-card-table background-transparent" multiTemplateDataRows>
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef class="text-center">
                  &nbsp;&nbsp;
                </th>
                <td mat-cell *matCellDef="let buyOffer; let i = dataIndex;" class="text-center">
                  {{currentStart+i+1}}
                </td>
              </ng-container>
              <ng-container matColumnDef="TargetPrice">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Target Price
                </th>
                <td mat-cell *matCellDef="let buyOffer" class="cursor-pointer long-text-cut text-center">
                  {{buyOffer.price | currency:'USD':'symbol':'1.5-5'}}
                </td>
                <ng-container matColumnDef="expandedDetail">
                  <td mat-cell *matCellDef="let buyOffer; let i = dataIndex;" class="no-border"
                    [attr.colspan]="displayedColumns.length">
                    <div [@detailExpand]="id!=-1 && buyOffer.id === id ? 'expanded' : 'collapsed'">
                      @if (id!=-1 && buyOffer.id === id) {
                        <div class="body">
                          @if (!editOrderMode) {
                            <div>
                              <div class="card">
                                @if (i == 0) {
                                  <div class="right-margin">
                                    <div class="right-margin-icon info-icon cursor-pointer"
                                      (click)="iIconPopup('Open tab contains a list of your active orders. Newly created orders can be updated or deleted. Accepted orders can not be updated or deleted.')">
                                    </div>
                                  </div>
                                }
                                <div class="body">
                                  <p class="accountInfoBorder">Price</p>
                                  <p class="subUniqueTitle">
                                    {{buyOffer.price |
                                    currency:'USD':'symbol':'1.5-5'}}/kWh
                                  </p>
                                  <p class="accountInfoBorder">Service Start</p>
                                  <p class="subUniqueTitle">
                                    1st meter read on or after {{buyOffer.termFrom |
                                    date:'shortDate'}}
                                  </p>
                                  <p class="accountInfoBorder">Service End</p>
                                  <p class="subUniqueTitle">
                                    1st meter read on or after
                                    {{getTermTo(buyOffer.termFrom, buyOffer.termPeriod)
                                    | date:'shortDate'}}
                                  </p>
                                  <p class="accountInfoBorder">Term</p>
                                  <p class="subUniqueTitle">
                                    {{buyOffer.termPeriod}} months
                                  </p>
                                  <p class="accountInfoBorder">Offer Duration</p>
                                  <p class="subUniqueTitle">
                                    Good until {{buyOffer.validDate | date:'shortDate'}}
                                  </p>
                                  @if (buyOffer.accounts.length>0) {
                                    <div class="account-info-block">
                                      <p class="card-block-background" [class]="(viewBuyOfferAccounts[i])?'':'view-closed'">
                                        Associated Accounts
                                        <a [class]="(viewBuyOfferAccounts[i])?'collapse':'open'"
                                        (click)="viewBuyOfferAccounts[i]=!viewBuyOfferAccounts[i]"></a>
                                      </p>
                                      <div [class]="(viewBuyOfferAccounts[i])?'visible':'hidden'">
                                        <kilowant-accounts-listing [accounts]="buyOffer.accounts"></kilowant-accounts-listing>
                                      </div>
                                    </div>
                                  }
                                  <div class="block-buttons full-width small mt-20">
                                    <button type="button" (click)="editBuyOffer(buyOffer)">
                                      Edit
                                    </button>
                                    <button type="button" (click)="deleteBuyOffer(buyOffer)">
                                      Delete
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                          @if (editOrderMode) {
                            <kilowant-buy-offer-edit [id]="id" (cancelled)="cancel()" class="mt-50" (finished)="finish(false)"></kilowant-buy-offer-edit>
                          }
                        </div>
                      }
                    </div>
                  </td>
                </ng-container>
              </ng-container>
              <ng-container matColumnDef="ServiceStart">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Service Start
                </th>
                <td mat-cell *matCellDef="let buyOffer" class="cursor-pointer long-text-cut text-center">
                  {{buyOffer.termFrom | date:'shortDate'}}
                </td>
              </ng-container>
              <ng-container matColumnDef="ServiceEnd">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Service End
                </th>
                <td mat-cell *matCellDef="let buyOffer" class="cursor-pointer long-text-cut text-center">
                  {{getTermTo(buyOffer.termFrom, buyOffer.termPeriod) |
                  date:'shortDate'}}
                </td>
              </ng-container>
              <ng-container matColumnDef="ValidUntil">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Valid Until
                </th>
                <td mat-cell *matCellDef="let buyOffer" class="cursor-pointer long-text-cut text-center">
                  {{buyOffer.validDate | date:'shortDate'}}
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let buyOffer;let row; columns: displayedColumns;" (click)="viewOfferInfo(buyOffer)">
              </tr>
              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
            </table>
          </div>
        }
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label> Closed </ng-template>
        @if (closedBuyOffers==null || closedBuyOffers.length==0) {
          <div class="info-text">
            There is currently no orders
          </div>
        }
        @if (closedBuyOffers!=null && closedBuyOffers.length>0) {
          <div>
            <table #openOfferTable="matSort" mat-table matSort (matSortChange)="sortDataEvent($event)"
              [dataSource]="closedBuyOffers" matSortActive="ServiceStart" matSortDisableClear="true"
              matSortDirection="asc" class="offer-summmary-table in-card-table background-transparent"
              multiTemplateDataRows>
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef class="text-center">
                  &nbsp;&nbsp;
                </th>
                <td mat-cell *matCellDef="let closedBuyOffer; let i = dataIndex;" class="text-center">
                  {{currentStart+i+1}}
                </td>
              </ng-container>
              <ng-container matColumnDef="TargetPrice">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Target Price
                </th>
                <td mat-cell *matCellDef="let closedBuyOffer" class="cursor-pointer long-text-cut text-center">
                  {{closedBuyOffer.price | currency:'USD':'symbol':'1.5-5'}}
                </td>
                <ng-container matColumnDef="expandedDetail">
                  <td mat-cell *matCellDef="let closedBuyOffer; let i = dataIndex;" class="no-border"
                    [attr.colspan]="displayedColumns.length">
                    <div [@detailExpand]="id!=-1 && closedBuyOffer.id === id ? 'expanded' : 'collapsed'">
                      @if (id!=-1 && closedBuyOffer.id === id) {
                        <div class="body">
                          <div class="card">
                            <div class="body">
                              <p class="accountInfoBorder">Service Start</p>
                              <p class="subUniqueTitle">
                                1st meter read on or after {{closedBuyOffer.termFrom |
                                date:'shortDate'}}
                              </p>
                              <p class="accountInfoBorder">Service End</p>
                              <p class="subUniqueTitle">
                                1st meter read on or after
                                {{getTermTo(closedBuyOffer.termFrom,
                                closedBuyOffer.termPeriod) | date:'shortDate'}}
                              </p>
                              <p class="accountInfoBorder">Term</p>
                              <p class="subUniqueTitle">
                                {{closedBuyOffer.termPeriod}} months
                              </p>
                              <p class="accountInfoBorder">Price</p>
                              <p class="subUniqueTitle">
                                {{closedBuyOffer.price |
                                currency:'USD':'symbol':'1.5-5'}}/kWh
                              </p>
                              <p class="accountInfoBorder">Good Until</p>
                              <p class="subUniqueTitle">
                                {{closedBuyOffer.validDate | date:'shortDate'}}
                              </p>
                              <div class="account-info-block">
                                <p class="card-block-background" [class]="(viewClosedBuyOfferAccounts[i])?'':'view-closed'">
                                  Associated Accounts
                                  <a [class]="(viewClosedBuyOfferAccounts[i])?'collapse':'open'"
                                  (click)="viewClosedBuyOfferAccounts[i]=!viewClosedBuyOfferAccounts[i]"></a>
                                </p>
                                <div [class]="(viewClosedBuyOfferAccounts[i])?'visible':'hidden'">
                                  <kilowant-accounts-listing
                                  [accounts]="closedBuyOffer.accounts"></kilowant-accounts-listing>
                                </div>
                              </div>
                            </div>
                            <div class="block-buttons full-width small mt-20">
                              <button type="button" (click)="deleteBuyOffer(closedBuyOffer)">
                                Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </td>
                </ng-container>
              </ng-container>
              <ng-container matColumnDef="ServiceStart">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Service Start
                </th>
                <td mat-cell *matCellDef="let closedBuyOffer" class="cursor-pointer long-text-cut text-center">
                  {{closedBuyOffer.termFrom | date:'shortDate'}}
                </td>
              </ng-container>
              <ng-container matColumnDef="ServiceEnd">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Service End
                </th>
                <td mat-cell *matCellDef="let closedBuyOffer" class="cursor-pointer long-text-cut text-center">
                  {{getTermTo(closedBuyOffer.termFrom, closedBuyOffer.termPeriod) |
                  date:'shortDate'}}
                </td>
              </ng-container>
              <ng-container matColumnDef="ValidUntil">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Valid Until
                </th>
                <td mat-cell *matCellDef="let closedBuyOffer" class="cursor-pointer long-text-cut text-center">
                  {{closedBuyOffer.validDate | date:'shortDate'}}
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let closedBuyOffer;let row; columns: displayedColumns;"
              (click)="viewOfferInfo(closedBuyOffer)"></tr>
              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
            </table>
          </div>
        }
      </mat-tab>
    </mat-tab-group>

    <div class="block-buttons under-card" style="margin-top: 25px;">
      @if (!editOrderMode) {
        <button type="button" (click)="addBuyOffer()">
          Add Order
        </button>
      }
    </div>
  </div>
</div>